module.exports = __webpack_public_path__ + "static/img/WIL-DAWSON.455120d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WIL-DAWSON.jpg
// module id = TQGI
// module chunks = 0